import { aiApi } from '~/modules/query/ai';
import type {
  ConfigListResponse,
  CreateConfigRequest,
  SaveConfigResponse,
  TokenLimitSettings,
  TokenLimitSettingsResponse,
  TokenUsage,
  UpdateConfigRequest,
  UsageStats,
  UsageStatsArgs,
} from '~/modules/query/ai/types';

const seg = encodeURIComponent;

export const settingsApi = aiApi.injectEndpoints({
  endpoints: (builder) => ({
    listConfigs: builder.query<ConfigListResponse, void>({
      query: () => ({ url: '/manager/settings', method: 'GET' }),
      providesTags: ['AiSettings'],
    }),
    createConfig: builder.mutation<SaveConfigResponse, CreateConfigRequest>({
      query: (data) => ({ url: '/manager/settings', method: 'POST', data }),
      invalidatesTags: ['AiSettings'],
    }),
    updateConfig: builder.mutation<SaveConfigResponse, UpdateConfigRequest>({
      query: ({ componentKey, updates, changeNote }) => ({
        url: `/manager/settings/${seg(componentKey)}`,
        method: 'PATCH',
        data: { ...updates, changeNote },
      }),
      invalidatesTags: ['AiSettings'],
    }),

    getUsage: builder.query<TokenUsage, void>({
      query: () => ({ url: '/manager/usage', method: 'GET' }),
      providesTags: ['AiUsage'],
    }),
    getUsageStats: builder.query<UsageStats, UsageStatsArgs>({
      query: (args) => ({ url: '/manager/usage/stats', method: 'GET', params: args }),
      providesTags: ['AiUsage', 'AiUsageStats'],
    }),
    getTokenLimits: builder.query<TokenLimitSettingsResponse, void>({
      query: () => ({ url: '/manager/usage/limits', method: 'GET' }),
      providesTags: ['AiTokenLimits', 'AiUsage'],
    }),
    updateTokenLimits: builder.mutation<TokenLimitSettingsResponse, TokenLimitSettings>({
      query: (data) => ({ url: '/manager/usage/limits', method: 'PATCH', data }),
      invalidatesTags: ['AiTokenLimits', 'AiUsage'],
    }),
  }),
});

export const {
  useListConfigsQuery,
  useCreateConfigMutation,
  useUpdateConfigMutation,
  useGetUsageQuery,
  useGetUsageStatsQuery,
  useGetTokenLimitsQuery,
  useUpdateTokenLimitsMutation,
} = settingsApi;
